import { Link } from 'react-router-dom';
import { Home, Mail, RefreshCw } from 'lucide-react';

/**
 * Barra inferior de accesos rápidos (Inicio / Sincronizar / Reportar).
 * @param {{ onRefresh: () => void; refreshing?: boolean }} props
 */
export default function BottomNav({ onRefresh, refreshing = false }) {
  return (
    <nav
      className="glass-header fixed bottom-0 left-0 right-0 z-40 rounded-t-3xl border-t border-white/50 shadow-nav-up pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-2"
      aria-label="Accesos rápidos"
    >
      <div className="mx-auto flex h-[4.5rem] max-w-md items-center justify-around px-8">
        <Link
          to="/"
          className="flex flex-col items-center gap-1 text-muted-foreground transition-colors hover:text-primary"
        >
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-md">
            <Home className="h-5 w-5" aria-hidden />
          </span>
          <span className="text-[10px] font-bold uppercase tracking-widest">Inicio</span>
        </Link>
        <button
          type="button"
          onClick={onRefresh}
          disabled={refreshing}
          className="flex flex-col items-center gap-1 text-muted-foreground transition-colors hover:text-primary disabled:opacity-50"
          aria-label="Actualizar"
        >
          <span className="flex h-11 w-11 items-center justify-center rounded-full transition-transform active:scale-90">
            <RefreshCw className={`h-6 w-6 ${refreshing ? 'animate-spin' : ''}`} />
          </span>
          <span className="text-[10px] font-bold uppercase tracking-widest">Sincronizar</span>
        </button>
        <a
          href="mailto:contacto@paine.cl?subject=Reporte%20MuniBus"
          className="flex flex-col items-center gap-1 text-muted-foreground transition-colors hover:text-primary"
        >
          <span className="flex h-11 w-11 items-center justify-center rounded-full transition-transform active:scale-90">
            <Mail className="h-6 w-6" aria-hidden />
          </span>
          <span className="text-[10px] font-bold uppercase tracking-widest">Reportar</span>
        </a>
      </div>
    </nav>
  );
}
